import {getConfigItem, configConstants} from '@servicenow/ui-config';
import ajv from '../ajv';
import validateSchema from '../validate/validateSchema';

const {VALIDATE_SCHEMAS} = configConstants;
const validateSchemas = getConfigItem(VALIDATE_SCHEMAS);

/**
 * Build the validator for the config of a component
 * @private
 * @param {*} schema The schema of the config to validate against
 * @returns {Function(config, errorPrefix, options)} The function to validate the component's properties
 */
function buildConfigValidator(schema) {
	if (validateSchemas) {
		let validate;
		try {
			validate = ajv.compile(schema);
		} catch (e) {
			console.error(e); // eslint-disable-line no-console
			return () => false;
		}

		return function validator(config, errorPrefix, options = {}) {
			return validateSchema(validate, config, {errorPrefix, ...options});
		};
	}

	return () => true;
}

export default buildConfigValidator;
